import Home from "./pages/index";
import { RouteConfig } from "@routing";

export const routes:RouteConfig[] = [
	{
		path:"/",
		component:Home,
	}
];